export const enCA = {
    name: "enCA",
    conversions: {
        fromMeters: (input) => {
            return (input / 1000.0);
        },
        toMeters: (input) => {
            return (input * 1000.0);
        },
    },
    strings: {
        zip: "Postal Code",
        state: "Province",
        distanceUnit: "km",
        distanceUnitPlural: "km",
    },
};
//# sourceMappingURL=en-ca.js.map